module.exports = __webpack_public_path__ + "static/media/room_5-3.23329ae1.jpeg";